// extracted by mini-css-extract-plugin
module.exports = {"App":"Terms__App__hLH4C","Center":"Terms__Center__2J9GH","Row":"Terms__Row__WTGfk","RowH":"Terms__RowH__3UkAA","Text":"Terms__Text__2UvLs","Width":"Terms__Width__SOLsi"};